import React, { useEffect, useRef, useState } from "react";
import { FunctionalInput } from "../../../../Common/fInputs";
import { Modal } from "../../../../Common/fModal/Modal";
import { Select } from "../../../../Common/Class/Select";
// import { ProductSearch } from "../../../fVendor/fProcurement/fRfqDetails/ProductSearch";
import { get } from "../../../../../Model/Network/Config/Axios";
import ProductSearch from "../../Submit/ProductSearch";
import _ from 'lodash';
import ToggleSwitch from "../../../../Common/fSwitch";
import TdsLineItem from "./TdsLineItem";
import SelectGST from "../../../../Common/fUtils/SelectGST";
import { showToast } from "../../../../Common/fToast/ToastCallback";
import { checkRCMStatusonInvoiceLevel } from "./checkRCMStatus";
import { Form2 } from "../../../../Common/Class/Form2";
import { numberWithCommas } from "../../../../../Utils/NumberToComma";

const LineItemModal = ({
  allowTdsAtLineItem = true,
  dependentmasterValueLineItem = {},
  updateLineItemCustomForm,
  tenant,
  details,
  close,
  edit,
  onSave,
  categoryId,
  category,
  vendorId,
  tdsAtLineItem = false,
  contractId,
  tdsAtLineItemInContract = false,
  disableUpdate,
  isCreditNote,
  searchProductByService = false,
  disableRcm = false,
  tdsSlabs,
  vendor,
  tdsAtLineItemAutomation = false,
  hideGlField = false,
  tdsAutomationAtCreditNoteLineItem = false,
  currency = 'INR'
}) => {
  
  let categoryList = ["BCCD CRM","BCCD Non - CRM"]
  const QTY = useRef(),
    MATERIAL = useRef(),
    UNIT = useRef(),
    PRICE = useRef(),
    NAME=useRef(),
    GLCODE=useRef(),
    CESS=useRef();

  const [gst, setGst] = useState({
    value: 2,
    label: 2,
  });
  
  const [, setProduct] = useState(undefined);
	const [updated,setUpdated] = useState({
		content:{}
	});
  const [singleService, setSingleService] = useState({});
	const [services, setServices] = useState([]);
	const [toggle, setToggle] = useState(false);
	const [cessValue, setCessValue] = useState('');
  const CUSTOMFORM = useRef(null);
  const [forms,setForms] = useState([]);
  const [prefillForms,setPrefillForms] = useState({});
  const [pendingUpdate,setPendingUpdate] = useState(undefined);
  const [selectedItems,setSelectedItems] = useState({});
  const [applying,setApplying] = useState(false);
  const hideGlCode= (tenant==='STELMC' || tenant==='ANRCK' || tenant==='ANAROCK');
  const tenantCheck = ['TESTASK','ASK'].includes(tenant);

  useEffect(() => {
    if (edit) {
      setProduct({ hsn: edit.hsn, name: edit.desc, label: edit.desc })
      QTY.current.value = edit.qtty || 0
      PRICE.current.value = edit.price
      MATERIAL.current.value = edit.hsn || ''
      UNIT.current.value = edit.unit || ''
      setGst({
        value: edit.taxSlab,
        label: edit.taxSlab
      })
      if (edit.service) {
        setSingleService({
          label: edit.service,
          value: null,
        })
        NAME.current.setValue({title:edit.desc,id:edit.productId})
      }
      if(edit.cessPercent){
        setCessValue(edit.cessPercent)
      }
      if(edit && edit.glCode){
        if(!hideGlField && GLCODE && GLCODE.current){
          GLCODE.current.value = edit.glCode || ''
        }
      }
      setToggle(edit.rcItem)
      //CN Credit Note
      if(categoryId){
        let formKey = isCreditNote
          ? `finance::creditNote::item::${categoryId}`
          : (details && details.status === 'TAXATION_APPROVAL')
            ? `taxation::invoice::item::${categoryId}`
            : `finance::invoice::item::${categoryId}`;
        get(`forms/${formKey}`, (e, r) => {
          if(r && r.forms){
            setForms(r.forms);
            // saved values live on the line item keyed by the form field id,
            // but Form2 prefills by fieldId - so map them through the schema
            let saved = {};
            if(edit.attrs){
              saved = {...edit.attrs};
            }
            if(edit.formData && edit.formData.length > 0){
              for(let i=0;i<edit.formData.length;i++){
                saved[edit.formData[i].id] = edit.formData[i].value;
              }
            }
            let obj = {};
            r.forms.forEach(field => {
              if(saved[field.id] !== undefined){
                obj[field.fieldId] = saved[field.id];
              }
            })
            setPrefillForms(obj);
          }
        })
      }

    }
  },[edit])

  // push the schema in only once the prefill values are ready, so Form2 can
  // seed the fields with them on mount
  useEffect(() => {
    if(forms.length > 0 && CUSTOMFORM.current){
      CUSTOMFORM.current.customForm(forms);
    }
  },[forms,prefillForms])

  useEffect(() => {
    if(categoryId){
		get(`vendor/config/${categoryId}/services`, (e, r) => {
			if (r) {
				setServices(r.items.map(i => {
					return {
						value: i.id,
						label:  i.name,
						cess:i.cess,
            des:i.glCode ? `glCode- ${i.glCode}` : ''
					}
				}))
				if (r.items.length > 0 && !edit.service ) {
					setSingleService({
						label: r.items[0].glCode ? `${r.items[0].name} glCode- ${r.items[0].glCode}` : r.items[0].name,
						value: r.items[0].id,
						cess:r.cess,
            des:r.items[0].glCode ? `glCode- ${r.items[0].glCode}` : ''
					})
				}

			}
		})
  } 
	}, [categoryId])

  // const selectProduct = (product) =>{
  //   MATERIAL.current.value =  product.hsn || '';
  //   UNIT.current.value =  product.unit
  //   setGst({
  //       value:product.gst,
  //       label:product.gst,
  //   })
  //   setProduct(product)
  //   updateFunction("productId",Number(product.value))
  //   updateFunction("hsn",product.hsn)
  //   updateFunction("unit",product.unit)
  //   updateFunction("taxSlab",Number(product.gst))
  // }

  const updateFunction = (key,value) =>{
		let updateObject = {...updated};
		updateObject["content"][key] = value;
		setUpdated(updateObject);
	}

  const lineItems = (details && details.invoice && details.invoice.items) ? details.invoice.items : [];

  const lineItemLabel = (item) => {
    let parts = [];
    if(item.name) parts.push(item.name);
    if(item.service && item.service !== item.name) parts.push(item.service);
    if(!parts.length && item.desc) parts.push(item.desc);
    return parts.join(" - ") || `Item #${item.id}`;
  }

  // qty/rate/amount line so the item is identifiable when names repeat
  const lineItemMeta = (item) => {
    let parts = [];
    if(item.qtty !== undefined) parts.push(`Qty ${item.qtty}${item.unit ? ` ${item.unit}` : ''} x ${numberWithCommas(Number(item.price || 0).toFixed(2))}`);
    if(item.hsn) parts.push(`HSN ${item.hsn}`);
    if(item.taxSlab !== undefined) parts.push(`GST ${item.taxSlab}%`);
    if(item.amount !== undefined) parts.push(`${item.currency || currency} ${numberWithCommas(Number(item.amount).toFixed(2))}`);
    return parts.join("  •  ");
  }

  // what the field being updated currently holds on this line item
  const currentFieldValue = (item) => {
    if(!pendingUpdate || !item.attrs) return undefined;
    return item.attrs[pendingUpdate.id];
  }

  // a custom field can be pushed to more than one line item - ask which ones
  // before firing the update, starting with just the one being edited
  const askLineItems = (field,value) => {
    setSelectedItems({[edit.id]: true});
    setPendingUpdate({...field, value});
  }

  const toggleLineItem = (itemId) => {
    setSelectedItems(prev => ({...prev, [itemId]: !prev[itemId]}));
  }

  const selectedCount = lineItems.filter(item => selectedItems[item.id]).length;

  const allSelected = lineItems.length > 0 && selectedCount === lineItems.length;

  const toggleAllLineItems = () => {
    let obj = {};
    lineItems.forEach(item => { obj[item.id] = !allSelected });
    setSelectedItems(obj);
  }

  const applyPendingUpdate = async () => {
    let itemIds = lineItems.map(item => item.id).filter(itemId => selectedItems[itemId]);
    if(!itemIds.length){
      showToast({
        type: 'error',
        message: 'Please select at least one line item'
      })
      return;
    }
    setApplying(true);
    await updateLineItemCustomForm(pendingUpdate.id, pendingUpdate.value, itemIds);
    setApplying(false);
    setPendingUpdate(undefined);
  }

  return (
    <>
    <Modal
      show={true}
      des="Edit line item quantity"
      title={"Edit Line Item"}
      style={{
        save: {
          background: "var(--primary-color)",
          border: "2px solid var(--primary-color)",
          padding: "8px 15px",
          width: "100%",
          color: "white",
          curor: "pointer",
          textAlign: "center",
        },
      }}
      buttonName="Update"
      close={close}
      onSave={() => {
        let obj = {
           itemId:edit.id,
          ...updated["content"]
        }
        if(Object.keys(updated["content"]).length) {
          onSave(obj)
        } else {
          close()
        }
      }}
    >
        <Select
            disabled={disableUpdate}
            value={singleService}
            items={services}
            placeholder="Select Service"
            select={(service) => {
               updateFunction("serviceId",service.value || null)
              setSingleService(service)
            }}
          />
       <ProductSearch
        disabled={disableUpdate}
        services={searchProductByService && singleService && singleService.label}
        placeholder={"Name"}
         ref={NAME} 
         categoryId={categoryId}
         onChangeText={(item) => {
          item && item.id &&  updateFunction("productId",item.id)
          item && item.title &&  updateFunction("name",item.title)
          if(item && item.glCode && !hideGlCode){
            updateFunction("gl",item.glCode)
            if (!hideGlField && GLCODE && GLCODE.current) {
              GLCODE.current.value = item.glCode
            }
          }
         }}
         />
          <FunctionalInput
            disabled={disableUpdate}
            type="text"
            title="Material Code (HSN/SAC)"
            onChange={(e) =>{
              updateFunction("hsn",e.target.value)
            }}
             ref={MATERIAL}
          />
          {!hideGlField && 
          <FunctionalInput 
            style={{display:hideGlCode ? 'none' : 'block'}}
            disabled={disableUpdate}
            ref={GLCODE} 
            title="GL Code" 
            onChange={(e) =>{
              updateFunction("gl",e.target.value)
            }}
          />
          }
          <FunctionalInput
            disabled={disableUpdate}
            type="text"
            title="Unit"
            onChange={(e) =>{
              updateFunction("unit",e.target.value)
            }}
             ref={UNIT}
          />
        <FunctionalInput 
        disabled={_.includes(categoryList,category) || disableUpdate}
        ref={QTY} 
        title="Enter Quantity" 
        onChange={(e) =>{
          updateFunction("qty",Number(e.target.value))
        }}
        type="number"
        />
      {
        <>
          <FunctionalInput
           disabled={disableUpdate}
           ref={PRICE}
           title="Enter Price"
            type="number"
            onChange={(e) =>{
              updateFunction("price",Number(e.target.value))
            }} 
            />
          <SelectGST defaultValue={gst} placeholder={`Select ${currency==="INR"?"Gst":"Tax"}`} onSelect={(data) =>{
              if(['TESTASK','ASK'].includes(tenant) && !checkRCMStatusonInvoiceLevel(details) && Number(data.value) === 0){
                showToast({
                  type: 'error',
                  message: "RCM Invoice is not allowed when GST is 0. Need to turn off RCM Invoice"
                })
                return;
              }
              updateFunction("taxSlab",Number(data.value))
              setGst(data)
            }}/>
            {/* conditions merged */}
          {(tdsAutomationAtCreditNoteLineItem || (allowTdsAtLineItem && (((tdsAtLineItemAutomation && !contractId) || (tdsAtLineItem && !contractId)) || (contractId && tdsAtLineItemInContract)))) &&
            <div style={{ width: '100%', marginTop: 5 }}>
              <TdsLineItem 
                 disabled={disableUpdate}
                 vendorId={vendorId}
                 onSelect={(obj) =>  updateFunction("tds",obj)}
                 value={edit.tds ? edit.tds:null}
                 tdsSlabs={(tdsSlabs)?tdsSlabs:undefined}
                 vendor={vendor}
                 entityId={(details && details.entityId)?details.entityId:""}
              />
            </div>
          }
          {/* {tdsAutomationAtCreditNoteLineItem ?
            <div style={{ width: '100%', marginTop: 5 }}>
              <TdsLineItem 
                 disabled={disableUpdate}
                 vendorId={vendorId}
                 onSelect={(obj) =>  { updateFunction("tds",obj)}}
                 value={edit.tds ? edit.tds:null}
                 tdsSlabs={(tdsSlabs)?tdsSlabs:undefined}
                 vendor={vendor}
                 entityId={(details && details.entityId)?details.entityId:""}
              />
            </div>
            :null
          } */}
           {singleService.cess || edit.cessPercent ? (
            <FunctionalInput
              onChange={(e) => {
                if (e.target.value > 99) {
                  CESS.current.value = 0;
                  showToast({
                    type: "error",
                    message: "Cess value is not more than 99",
                  });
                }
                updateFunction("cess",Number(e.target.value))
                setCessValue(e.target.value)
              }}
              type="number"
              ref={CESS}
              defaultValue={cessValue}
              title="Enter Cess %"
              max="100"
            />
          ) : null}
          {!isCreditNote && !disableRcm && checkRCMStatusonInvoiceLevel(details) && !tenantCheck && <div style={{ marginTop: 20}}>
            <ToggleSwitch disabled={disableUpdate} status={toggle} 
              callback={(val) =>{
                if(val && ['TESTASK','ASK'].includes(tenant) && gst && gst.value === 0) {
                  showToast({
                    type: 'error',
                    message: "Tax Amount is 0, so RCM Invoice is not allowed"
                  })
                  setToggle(false)
                  return;
                }
              updateFunction("rcm_item",val)
              setToggle(val)
              }} label='RCM Invoice' />
          </div>}
         <div style={{marginTop:20}}>
         <Form2
            dependentKeyValue={dependentmasterValueLineItem}
            initialValues={prefillForms}
            handler={ref => CUSTOMFORM.current = ref}
            label={`${(details && details.status === 'TAXATION_APPROVAL' && !isCreditNote) ? 'Taxation' : 'Finance'} Line Item Field`}
            updateForm={(key, value, name) => {
              // this was changed to handle the issue with the key not being the id
              let id="";
              let fieldName="";
              for(let i=0;i<forms.length;i++){
                if(forms[i].fieldId === key){
                  id=forms[i].id;
                  fieldName=forms[i].name;
                  break;
                }
              }
              if(lineItems.length > 1 && typeof name !== 'boolean'){
                askLineItems({id, fieldName}, value);
                return;
              }
              return updateLineItemCustomForm(id, value, edit.id)
            }}
            tenant={tenant}
            categoryId={categoryId || null}
          />
         </div>
        </>
      }
    </Modal>
    {
      pendingUpdate ?
      <Modal
        show={true}
        zIndex={1100}
        title={"Apply To Line Items"}
        des={`Select the line items that should get ${pendingUpdate.fieldName || 'this field'}${pendingUpdate.value ? ` = ${pendingUpdate.value}` : ''}`}
        buttonName={selectedCount ? `Update ${selectedCount} Line ${selectedCount > 1 ? 'Items' : 'Item'}` : "Select Line Items To Update"}
        stateLoading={applying}
        close={() => { if(!applying) setPendingUpdate(undefined) }}
        style={{
          save: {
            background: selectedCount ? "var(--primary-color)" : "#c7cbd4",
            border: `2px solid ${selectedCount ? "var(--primary-color)" : "#c7cbd4"}`,
            padding: "8px 15px",
            width: "100%",
            color: "white",
            cursor: selectedCount ? "pointer" : "not-allowed",
            textAlign: "center",
          },
        }}
        onSave={applyPendingUpdate}
      >
        <div style={{display:'flex',alignItems:'center',marginBottom:12}}>
          <p style={{fontSize:13,color:'#667085'}}>{selectedCount} of {lineItems.length} selected</p>
          <p onClick={toggleAllLineItems} style={{
            marginLeft:'auto',
            fontWeight:600,
            fontSize:12,
            cursor:'pointer',
            color: allSelected ? "var(--red-color)" : "var(--primary-color)"
          }}>{allSelected ? "Deselect All" : "Select All"}</p>
        </div>
        <div style={{maxHeight:320,overflowY:'auto',border:'1px solid var(--border-color)',borderRadius:8,padding:8}}>
          {lineItems.map((item,index) => {
            let existing = currentFieldValue(item);
            return (
            <div key={item.id} style={{display:'flex',alignItems:'flex-start',padding:'10px 6px',borderBottom: index === lineItems.length-1 ? 'none' : '1px solid var(--border-color)'}}>
              <input
                type="checkbox"
                id={`apply_${item.id}`}
                checked={selectedItems[item.id] ? true : false}
                onChange={() => toggleLineItem(item.id)}
                style={{marginRight:10,marginTop:3,cursor:'pointer'}}
              />
              <label htmlFor={`apply_${item.id}`} style={{flex:1,cursor:'pointer',color:'#101828'}}>
                <div style={{fontWeight:600,fontSize:13}}>
                  {index + 1}. {lineItemLabel(item)}
                  {item.id === edit.id ? <span style={{marginLeft:6,fontSize:11,fontWeight:500,color:'var(--primary-color)'}}>(current)</span> : null}
                </div>
                <div style={{fontSize:12,color:'#667085',marginTop:3}}>{lineItemMeta(item)}</div>
                <div style={{fontSize:12,marginTop:3}}>
                  <span style={{color:'#667085'}}>{pendingUpdate.fieldName || 'Current'} : </span>
                  {existing ?
                    <span style={{color:'#101828',fontWeight:500}}>{existing}</span>
                    : <span style={{color:'#98a2b3'}}>not set</span>
                  }
                  {(existing && String(existing) !== String(pendingUpdate.value)) ?
                    <span style={{color:'var(--red-color)',marginLeft:6}}>will be replaced with {pendingUpdate.value}</span>
                    : null
                  }
                </div>
              </label>
            </div>
            )
          })}
        </div>
      </Modal>
      : null
    }
    </>
  );
};

export default LineItemModal;
